import React from 'react';
import Tooltip from '@atlaskit/tooltip';
//@ts-ignore
import EntitlementIcon from '@css-xp/base/entitlement-icon';
import classNames from 'classnames';
import { defaultTo } from 'lodash';
import { EntitlementDetails as Entitlement } from '@css-xp/graphtypes/src/generated-types-new';

export const HeaderIcon = (entitlement: Entitlement) => {
  const { billingStatus, productId, platform, logoId } = entitlement;
  const isCloud = platform?.trim().toUpperCase() === 'CLOUD';
  const content = defaultTo(entitlement.productName, '');

  return (
    <Tooltip content={content} position="right-end" truncate>
      <div
        className={classNames('header-icon-container avatar', {
          deactivated: billingStatus === 'SUSPENDED',
          deleted: billingStatus === 'DELETED',
        })}
      >
        <EntitlementIcon
          logoId={logoId as string}
          productId={productId as string}
          className="header-icon"
          isCloud={isCloud}
        />
      </div>
    </Tooltip>
  );
};
